import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const GenerationSettings = ({ settings, onSettingsChange }) => {
  const creativityOptions = [
    { value: 'low', label: 'Conservative (Low Creativity)' },
    { value: 'medium', label: 'Balanced (Medium Creativity)' },
    { value: 'high', label: 'Creative (High Creativity)' }
  ];

  const lengthOptions = [
    { value: 'short', label: 'Short' },
    { value: 'medium', label: 'Medium' },
    { value: 'long', label: 'Long' }
  ];

  const handleSettingChange = (field, value) => {
    onSettingsChange({ ...settings, [field]: value });
  };

  return (
    <div className="bg-muted/50 rounded-lg p-4 space-y-4">
      <h4 className="font-medium text-foreground mb-3">Generation Settings</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Creativity Level"
          options={creativityOptions}
          value={settings?.creativity || 'medium'}
          onChange={(value) => handleSettingChange('creativity', value)}
        />
        
        <Select
          label="Content Length"
          options={lengthOptions}
          value={settings?.length || 'medium'}
          onChange={(value) => handleSettingChange('length', value)}
        />
      </div>
      <div className="space-y-3">
        <Checkbox
          label="Include Statistics"
          description="Add relevant industry statistics and data"
          checked={settings?.includeStats || false}
          onChange={(e) => handleSettingChange('includeStats', e?.target?.checked)}
        />
        
        <Checkbox
          label="Add Quotes"
          description="Include relevant quotes from authors or industry experts"
          checked={settings?.includeQuotes || false}
          onChange={(e) => handleSettingChange('includeQuotes', e?.target?.checked)}
        />
        
        <Checkbox
          label="Fact Check"
          description="Ensure all generated content is factually accurate"
          checked={settings?.factCheck || true}
          onChange={(e) => handleSettingChange('factCheck', e?.target?.checked)}
        />
      </div>
    </div>
  );
};

export default GenerationSettings;